import Vue from 'vue';
import MarketConfigPlugin from '@nuskin/ns-market-config-vue';

export default () => {
  Vue.use(MarketConfigPlugin);
}
